import {AxiosInstance} from 'axios';
import {$activeSpanId} from '../../../stores/spanStore';

const SPAN_ID_HEADER = 'X-Resware-AI-Span-Id';

export function addSpanIdInterceptor(instance: AxiosInstance): void {
  instance.interceptors.request.use(config => {
    const spanId = $activeSpanId.get();
    if (spanId) {
      config.headers[SPAN_ID_HEADER] = spanId;
    }
    return config;
  });
}
